import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=00b9ecef&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"
import style1 from "./TermsAndConditions.vue?vue&type=style&index=1&id=00b9ecef&prod&scoped=true&lang=css"
import style2 from "./TermsAndConditions.vue?vue&type=style&index=2&id=00b9ecef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b9ecef",
  null
  
)

export default component.exports